import { useState, createContext } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import { getCategoriesService } from "../../../services/publicServices";

export const categoryPublicContext = createContext({
  categories: [],
  setCategories: () => {},
  filter: "",
  setFilter: () => {},
  sort: "",
  setSort: () => {},
  handleGetCategories: () => {},
});

const CategoryPublicContext = ({ children }) => {
  const dispatch = useDispatch();

  const { category } = useParams();

  const [categories, setCategories] = useState([]);
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("");

  // Get Categories
  const handleGetCategories = async (event) => {
    event?.preventDefault();

    const isSub = !!category;

    const objData = {
      sort,
      filter,
      ...(isSub && { categoryId: category }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getCategoriesService(objData);
      if (status === 200) {
        setCategories(data.result?.categories);
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <categoryPublicContext.Provider
      value={{
        categories,
        setCategories,
        filter,
        setFilter,
        sort,
        setSort,
        handleGetCategories,
      }}
    >
      {children}
    </categoryPublicContext.Provider>
  );
};

export default CategoryPublicContext;
